import { inject, Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import { AUTO_SUBSCRIPTION } from "src/app/constants/endpoint.const";

@Injectable({
    providedIn: 'root',
})

export class SubscriptionService {
    private baseService = inject(BaseService);

    autoSubscription(params: { auto_subscription: boolean }) {
        return this.baseService.putData(AUTO_SUBSCRIPTION, params, null, null);
    }
}